export default __webpack_public_path__ + "static/media/drizzle.586dab4f.png";